<template>
	<div>
		<el-drawer :title="title" :visible.sync="editFormVisible" @click="closeDialog" :size="600"
			:wrapperClosable="false" :modal='false' :destroy-on-close='true' class="margin_top_40">
			<el-form label-width="8.75rem" :model="editForm" :rules="rules" ref="editForm" class="demo-form-inline"
				inline>
				<el-form-item label="条件编号" prop="code">
					<el-input class="input_200px" size="small" v-model="editForm.code" auto-complete="off" placeholder="请输入条件编号"></el-input>
				</el-form-item>
				<el-form-item label="条件名称" prop="name">
					<el-input class="input_200px" size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入条件名称"></el-input>
				</el-form-item>
				<el-form-item label="类型" prop="type">
					<el-select size="small" class="input_200px" v-model="editForm.type" placeholder="请选择">
						<el-option v-for="item in addType" :key="item.keyId" :label="item.value" :value="item.keyId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否使用" prop="isUse">
					<el-switch v-model="editForm.isUse" active-color="#13ce66" inactive-color="#d8d8d8">
					</el-switch>
				</el-form-item>
			</el-form>
			<div class="drawer-footer">
				<el-button size="small" icon="el-icon-check" :loading="saveloading" class="title" @click="submitForm('editForm')">
					保存
				</el-button>
			</div>
		</el-drawer>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				saveloading: false,
				editFormVisible: false, //控制编辑页面显示与隐藏
				title: '条件',
				// 编辑表单
				editForm: {
					keyId: "",
					menuCode: "",
					code: "",
					name: "",
					type: "",
					isUse: true,
				},
				addType: [{
					keyId: '1',
					value: '设置流转形式'
				}, {
					keyId: '2',
					value: '设置流转条件'
				}],
				// rules表单验证
				rules: {
					code: [{
						required: true,
						message: '请输入条件编号',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '请输入条件名称',
						trigger: 'blur'
					}],
				},
			};
		},
		components: {},
		watch: {},
		created() {},
		methods: {
			//显示编辑界面
			editShow(row) {
				this.$data.editForm = this.$options.data.call(this).editForm;
				this.editFormVisible = true;
			},

			// 编辑、增加页面保存方法
			submitForm(editForm) {
				this.$refs[editForm].validate((valid) => {
					if (valid) {
						this.editFormVisible = false;
						this.$parent.updateDtls(this.editForm);
					} else {
						return false;
					}
				});
			},


			// 关闭编辑、增加弹出框
			closeDialog() {
				this.saveloading = false;
				this.editFormVisible = false;
				this.$refs['editForm'].resetFields();
			},

		},
	};
</script>
<style scoped>

	/deep/ .el-switch__core {
		width: 40px !important;
	}
</style>